import { render, staticRenderFns } from "./OrdenCompraRecepcionConforme.vue?vue&type=template&id=5624266e&"
import script from "./OrdenCompraRecepcionConforme.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraRecepcionConforme.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraRecepcionConforme.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports